// extracted by mini-css-extract-plugin
module.exports = {"sort":"DN","sortSelect":"EN","disabled":"FN"};